<template>
    <div>
        <Topheader></Topheader>
        <div class="w1100 q-body">

            <div class="top-body">
                <div class="top-left">
                    <img class="head-img" :src="info.head_url" alt="">
                </div>
                <div class="top-right">
                    <div class="send-btn" :class="content.length>0 ? 'send-btn-a' : ''" @click="onPost()">发送</div>
                </div>
            </div>

            <div class="ask-name">给{{info.name}}： </div>

            <textarea v-model="content" placeholder="写下您的问题…"></textarea>

        </div>
    </div>
</template>

<script>
    import Topheader from "../components/header"; //上传图片
    export default {
        components: {
            Topheader
        },
        name: "askQ",
        data() {
            return {
                userId:'',
                content: '',
                info:{}
            };
        },
        created() {
            this.userId=this.$route.query.id;
            this.getInfo();
        },
        //方法定义
        methods: {
            //获取用户信息
            getInfo(){
                let _this=this;
                _this.common.request('api/user/info',{id:_this.userId},function (res) {
                    _this.info=res.data;
                })
            },
            onPost(){
                if(this.content.length <= 0){
                    this.common.vMessage('请填写您要提问的内容','warning');
                    return;
                }
                let _this=this;
                let data={
                    answer_user_id:_this.userId,
                    question_info:_this.content,
                }
                _this.common.request('api/dynamic/addQuestion',data,function (res) {
                    if(res.status == 200){
                        _this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1500,
                            center: true,
                            onClose: function(res) {
                                _this.$router.go(-1);
                            }
                        });
                    }
                },'post');


            }
        }
    }
</script>

<style scoped lang='less' rel="stylesheet/less">

    .q-body{
        height:703px;
        background:rgba(255,255,255,1);
        margin-top: 20px;
        padding: 20px;
    }
    .top-body{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .top-left{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .head-img{
        width:64px;
        height:64px;
        border-radius:50%;
    }
    .send-btn{
        width:94px;
        height:44px;
        background:rgba(232,232,232,1);
        border-radius:22px;
        text-align: center;
        line-height: 44px;
        color: #15A3F5;
        cursor: pointer;
    }
    .send-btn-a{
        background-color: #388DE5;
        color: #FFFFFF;
    }
    .top-name{
        margin: 0 20px;
        line-height: 10px;
    }
    .user-name{
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
    }
    .user-name-spk{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(87,87,87,1);
        margin-left: 10px;
    }
    .time-text{
        font-size:14px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(87,87,87,1);
        line-height: 10px;
    }
    .content-info{
        width: 1000px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
        line-height:28px;
        margin-top: 20px;
    }
    textarea{
        color: #333;
        font-size: 14px;
        outline: none;
        border: none;
        width: 100%;
        resize: none;
        height: 520px;
        margin-top: 30px;
    }
    .ask-name{
        font-size:20px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(72,72,72,1);
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/view/askQ.vue